// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_core_qrcode-scanner_qrcode-scanner_component_ts":"d45e78bb0dd7379a","node_modules_jszip_dist_jszip_min_js":"2984534344e0d77f","src_app_delivery_delivery_module_ts":"d809a4b45e68513f","node_modules_simple-keyboard_build_index_js":"499a8393f4136320"}[chunkId] + ".js";
};